exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SearchBox--hide-search[data-v-61194137] {\n  min-height: 40px;\n}\n@media (min-width: 768px) {.SearchBox--hide-search[data-v-61194137] {\n    flex-grow: 0\n}\n}\n.SearchBox--hide-search .SearchBox__search-bar[data-v-61194137] {\n  display: none;\n}\n.SearchBox--hide-search .SearchBox__categories[data-v-61194137] {\n  border-radius: 30px;\n}\n.SearchBox--hide-categories .SearchBox__categories[data-v-61194137] {\n  display: none;\n}\n.SearchBox--hide-categories .SearchBox__search-bar[data-v-61194137] {\n  height: 48px;\n  border-radius: 30px;\n}\n", ""]);

// exports
